<template lang="pug">
Layout(include-layout-class="true")
   .TeamCreateContainer._relative(style="min-height: 300px")
      Loading(v-if="busy || loading" radius)
      div(v-if="!loading")
         ._t-center._mb2 
            ._fs-4._mb05 Team name/type
            ._c-grey-500._fs-075 (Can be changed later)
         ._mb2
            form(@submit.prevent="handleSubmit" v-show="addTeamTempState && addTeamTempState.company")
               ._mb2
                  ._flex._fs-075._c-grey-600
                     ._c-grey-500 {{addTeamTempState && addTeamTempState.company.ref ? 'Adding to: ' : 'Company: '}}
                     ._ml025._bold {{addTeamTempState && addTeamTempState.company && addTeamTempState.company.name}}
                     router-link._ml1.Btn.Btn--xs.Btn--white._ml-auto(to="/add-team/step-1") {{addTeamTempState && addTeamTempState.company.ref ? 'Change' : 'Edit'}} company
                  ._mt05._fs-05._c-red-800(v-if="companyNotUnique") Company name is not available
               ._mb1-5
                  label.InputLabel-value._c-grey-700._w100
                     ._mb075
                        .LabelText._mb025 Team name/type
                        ._c-grey-400._fs-05._mb025 Examples: Engineering/Software/Product/Mobile
                        .LabelError(v-if="showErrors && !$v.nameTeam.required") A team name is required
                        .LabelError(v-if="!$v.nameTeam.notContainTeam") Should not contain "team"
                     input.Input(tabindex="1" type="text" v-model.trim="nameTeam" placeholder="" v-on:keyup="createSlugOnNameInput")
               ._mb2
                  ._mb025._fs-05._c-grey-500 Your profile will live at:
                  ._c-grey-600._fs-075 
                     | https://www.remotefit.com/
                     span(v-if="slugForUrl")
                        | {{slugForUrl}}
                     span(v-else)
                        | {{this.addTeamTempState && this.addTeamTempState.company && this.addTeamTempState.company.slug}}/
                        code TEAM

               div
                  AddTeamNextBtn()
      //- ._fs-075
      //-    | Is your team already listed? 
      //-    router-link(to="/add-team/details/") Request to join
            //- ._my1._lineHeight--1dot4._p05._radius._bg-red-100(v-if="errors.general")
               ._fs-075._c-red-800 There was a problem. Please try again.
</template>

<style lang="sass" scoped>
.TeamCreateContainer
   max-width: 350px
   width: 100%
   +mx(auto)
   background-color: white
   border-radius: $radius
   +boxShadow--2
   +px($s-1)
   padding-top: $s-1-5
   padding-bottom: $s-1
   +above(375px)
      +px($s-1-5)
      padding-bottom: $s-1-5
</style>

<script>
import AddTeamNextBtn from '~/components/AddTeamNextBtn.vue'
import { mapState, mapGetters, mapMutations } from 'vuex'
import slugify from '@sindresorhus/slugify'
import * as faunaQueries from '~/faunaQueries.js'
import { required } from 'vuelidate/lib/validators'
import SlideToggle from '~/components/SlideToggle'

const notContainTeam = input => {
   if (!input) return true
   return input.toLowerCase().indexOf('team') < 0
}

export default {
   components: {
      AddTeamNextBtn,
      SlideToggle,
   },
   metaInfo() {
      return {
         title: `Step 2: Team name/type`,
      }
   },
   data() {
      return {
         loading: true,
         busy: false,
         showErrors: false,
         companyNotUnique: false,
         nameTeam: null,
         slugForUrlPlaceholder: null,
         slugForUrl: null,
         ip: this.$store.state.userIP,
      }
   },
   validations: {
      nameTeam: {
         required,
         notContainTeam,
      },
   },
   computed: {
      ...mapState(['addTeamTempState', 'makerState']),
   },
   methods: {
      createSlugOnNameInput() {
         if (this.nameTeam && this.nameTeam.length) {
            this.slugForUrl = this.addTeamTempState.company.slug + '/' + slugify(this.nameTeam)
         }
      },
      handleSubmit() {
         this.busy = true
         if (this.$v.$invalid) {
            this.busy = false
            this.showErrors = true
            return
         }

         const newTeamData = {
            // Team specific
            existingCompanyRef: this.addTeamTempState.company.ref,
            nameCompany: this.addTeamTempState.company.name,
            slugCompany: this.addTeamTempState.company.slug,
            // Team/TeamProfile specific
            nameTeam: this.nameTeam,
            slugTeamProfile: this.slugForUrl,
            // Other
            ip: this.ip,
         }

         return this.$store
            .dispatch('addTeam', newTeamData)
            .then(() => {
               // return this.$router.push('/add-team/plan').then(() => {
               //    this.$snotify.success('Team details saved')
               // })
               return this.$router
                  .push(`/${this.slugForUrl}/manage/`)
                  .then(() => this.$snotify.success('New team added. This is the page for managing it.', { timeout: 4000 }))
            })
            .catch(err => {
               if (err) {
                  if (err.message === 'instance not unique') {
                     this.companyNotUnique = true
                  }
               }
            })
            .finally(() => (this.busy = false))
      },
   },
   mounted() {
      // There should always be a company when viewing this page.
      // If there's not, redirect to step 1.
      if (!this.addTeamTempState || !this.addTeamTempState.company) {
         return this.$router.push('/add-team/step-1')
      }

      if (this.addTeamTempState.company.ref) {
         const co = this.makerState.companies.find(co => co.ref.id === this.addTeamTempState.company.ref.id)
         return this.$store
            .dispatch('updateNewTeamTempState', {
               company: {
                  name: co.data.name,
                  slug: co.data.slug.current,
               },
            })
            .finally(() => (this.loading = false))
      }

      this.loading = false
   },
}
</script>
